<template>
  <router-view></router-view>
</template>

<script>
import Vue from "vue";

export default Vue.extend({});
</script>



// WEBPACK FOOTER //
// src/features/refinance/RefinanceLayout.vue